import {Component, OnInit, Input} from '@angular/core';
import { PageBuilderDatasourcesModel } from '../page-builder-datasources.model';
import { MatDialog } from '@angular/material/dialog';
import { MDPageBuilderDatasourcePickerComponent } from '../md-datasources-picker/md-page-builder-datasource-picker.component';

@Component({
    selector: 'abw-page-builder-datasources',
    templateUrl: './page-builder-datasources.component.html',
    styleUrls: ['./page-builder-datasources.component.scss']
})
export class PageBuilderDatasourcesComponent implements OnInit {
    @Input() model: PageBuilderDatasourcesModel;

    constructor(
        private dialog: MatDialog
    ) {
    }

    ngOnInit() {
    }

    doOpenDatasourcesPickerDialog() {
        this.dialog.open(MDPageBuilderDatasourcePickerComponent);
    }
}